import React from 'react';
import styles from './Loader.module.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', fullScreen = false, text }) => {
  const loaderClasses = `${styles.loader} ${styles[size]}`;

  const content = (
    <div className={styles.loaderContainer}>
      <div className={loaderClasses}></div>
      {text && <p className={styles.loaderText}>{text}</p>}
    </div>
  );

  if (fullScreen) {
    return <div className={styles.fullScreen}>{content}</div>;
  }

  return content;
};

export default Loader;